import styled from 'styled-components'
import { h } from 'preact'

import Sizer_ from './atoms/sizer'

const Sizer = Sizer_.extend`
  display: flex;
  justify-content: space-between;
  width: 100%;
  a {
    color: #ccc;
    text-decoration: none;
  }
`

const Wrap = styled.footer`
  width: 100%;
  height: 60px;
  background: #373e44;
  text-align: center;
  line-height: 60px;
  color: #ccc;
  bottom: 0;
  position: absolute;
  display: flex;
`

export default () => (
  <Wrap>
    <Sizer>
      <div>
        <a href="http://rekonstrukcestatu.cz/">©2017 Rekonstrukce Státu</a>
      </div>
      <div>
        <a href="https://blog.skorepa.info/">Jakub Skořepa</a>
      </div>
    </Sizer>
  </Wrap>
)



// WEBPACK FOOTER //
// ./components/footer.js